import React, { useEffect } from 'react';
import '../../CSS/HomeButtonModel.css';
import {useHistory} from 'react-router-dom';
import {Card} from '@material-ui/core';

function NavigateButtonsModel(props){
    const history  = useHistory();

    function navigate(endpoint){
        if(endpoint!="marks"){
            if(props.type=="button"){
                history.push("/"+endpoint)
            }else{
                window.open(endpoint, '_self')
            }
        }else{
            
        }
    }

    return(
        <Card
        raised
        className="NavigateButtonsModel"
        onClick={()=>navigate(props.navigateLink)}
        >
            <img src={props.image} height="40px" width="40px" alt="Image" className="ImageNavigateButtonsModel"/>
            <div className="IdCardTextHome">
                {props.heading}
            </div>
        </Card>
    );

}

export default NavigateButtonsModel;